var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThunder = function SvgThunder(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0163 0.860171C12.3184 1.0449 12.4501 1.41573 12.3323 1.74964L10.3218 7.44596L13.4036 8.67866C13.6343 8.77096 13.8043 8.97156 13.8576 9.21431C13.9108 9.45706 13.8404 9.71042 13.6695 9.89083L6.91948 17.0158C6.67595 17.2729 6.28583 17.3246 5.98374 17.1399C5.68166 16.9551 5.54992 16.5843 5.66777 16.2504L7.67824 10.5541L4.59647 9.32138C4.36573 9.22908 4.19569 9.02848 4.14243 8.78573C4.08918 8.54299 4.15963 8.28962 4.33055 8.10921L11.0805 0.984212C11.3241 0.72716 11.7142 0.675445 12.0163 0.860171ZM6.17918 8.33892L8.90355 9.42866C9.27698 9.57803 9.46611 9.99537 9.33225 10.3746L8.25601 13.424L11.8208 9.66113L9.09647 8.57138C8.72304 8.42201 8.53391 8.00467 8.66777 7.62541L9.74402 4.57604L6.17918 8.33892Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThunder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thunder.0f07a0cf.svg";
export { ForwardRef as ReactComponent };